import React, { useEffect, useState } from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { adminAPI } from '../services/api';

export const UnmatchedFitmentsBanner = ({ refreshKey, onOpen }) => {
  const [total, setTotal] = useState(0);
  useEffect(() => { adminAPI.compatUnmatched().then(d => setTotal(d.total)).catch(() => setTotal(0)); }, [refreshKey]);
  if (!total) return null;
  return (
    <button type="button" onClick={onOpen} className="w-full mb-4 flex items-center gap-2 text-left text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-4 py-2.5 hover:bg-amber-100" data-testid="compat-unmatched-banner">
      <AlertTriangle size={16} className="text-amber-600 flex-shrink-0" />
      <span><strong>{total} modèle(s) de véhicule collé(s) non reconnu(s)</strong> dans la base — ajoutez-les ou associez-les pour activer le filtre par véhicule.</span>
      <ArrowRight size={16} className="ml-auto flex-shrink-0" />
    </button>
  );
};

export default UnmatchedFitmentsBanner;
